import _ from 'lodash';
import {
  setStateFormat,
  setDateFormat,
  setYearFormat,
  setAddressFormat,
  setIsRequired,
} from '../popups/setters';
import { parseName } from '@enotarylog/tag-utils';

export const defineAnnotClass = ({ className, baseClassName, methods = {}, customData = {} }) => async ({ instance, annotClasses, ...rest }) => {
  const C = class extends instance.Annotations[baseClassName] {
    constructor(...args) {
      super(...args);
      this.Subject = className;
      this.CustomData = { ...customData };
    }

    setSigner(id) {
      const signer = instance.getSignerById(id);
      const fullName = parseName(signer);

      this.FillColor = signer.color;
      // this.Author = signer.id;
      const customdata = {
        ...this.CustomData,
        ...customData,
        signerId: id,
        color: [signer.color.R, signer.color.G, signer.color.B, signer.color.A],
        name: fullName,
        fullName,
      };

      this.setContents(`${this.CustomData.label}: ${fullName}`);

      // this.setCustomData(customdata);
      this.CustomData = this.custom = customdata;

      instance.annotManager.redrawAnnotation(this);
      instance.annotManager.trigger('annotationChanged', [[this], 'modify', { imported: false, isUndoRedo: false }]);

      return this;
    }

    setIsRequired(isRequired) {
      return setIsRequired(isRequired, this, instance);
    }

    setDateFormat(dateFormat) {
      return setDateFormat(this, dateFormat, instance);
    }

    setYearFormat(yearFormat) {
      return setYearFormat(this, yearFormat, instance);
    }

    setStateFormat(stateFormat, signer) {
      return setStateFormat(this, stateFormat, signer, instance);
    }

    setAddressFormat(addressFormat, signer) {
      return setAddressFormat(this, addressFormat, signer, instance);
    }
  };


  _.chain(methods)
    .toPairs()
    .forEach(([name, fn]) => {
      C.prototype[name] = fn({ instance, annotClasses, ...rest });
    })
    .value();


  // C.prototype.elementName = className;
  Object.defineProperty(C, 'name', { value: className });

  return {
    ...rest,
    instance,
    annotClasses: {
      ...annotClasses,
      [className]: C,
    },
  };
};

export default defineAnnotClass;
